import { Col } from 'components/Col';
import { CustomCheckbox } from 'components/CustomCheckbox';
import { Row } from 'components/Row';
import { ProjetosContext } from 'contexts/projetos/ProjetosContext';
import {
  ChangeEvent,
  Fragment,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { useSelector } from 'react-redux';
import {
  getVisualizadoIsGestor,
  postVisualizadoCoordenador,
  postVisualizadoProfGestor,
} from 'services/projeto';
import languageValues from 'utils/LanguageUtils';
import SnackbarUtils from 'utils/SnackbarUtils';

export default function Visualizado(props: {
  chave: 'checkProfGestor' | 'checkCoordenador';
}) {
  const auth = useSelector((state: any) => state.auth);
  const isUserProfessorGestor =
    auth.userData.perfil === 'pufv_professor_gestor';
  const {
    state: { projeto, disabledFields },
    dispatch,
  } = useContext(ProjetosContext);

  const [isButtonDisabledByRole, setIsButtonDisabledByRole] = useState(false);

  const hasPermission = useMemo(
    () =>
      auth.userPermissions.projetos.viewChecker[
        props.chave === 'checkProfGestor'
          ? 'professorGestor'
          : 'coordenadorLocal'
      ],
    [auth.userPermissions.projetos.viewChecker, props.chave]
  );
  useEffect(() => {
    if (isUserProfessorGestor) {
      getVisualizadoIsGestor(projeto.id!)
        .then((response) => {
          setIsButtonDisabledByRole(!response.data);
        })
        .catch(() => {
          SnackbarUtils.error(
            languageValues.toasts.error.erroVerificacaoIsGestor
          );
        });
    }
  }, [isUserProfessorGestor, projeto.id]);

  return hasPermission ? (
    <Row>
      <Col>
        <CustomCheckbox
          name={props.chave}
          label={languageValues.inputs[props.chave].label}
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            const oldValue = projeto[props.chave];
            dispatch({
              type: 'setProjeto',
              payload: { [props.chave]: event.target.checked, dirty: false },
            });

            const req =
              props.chave === 'checkCoordenador'
                ? postVisualizadoCoordenador
                : postVisualizadoProfGestor;

            req(projeto.id!, event.target.checked)
              .then(() => {
                SnackbarUtils.success(
                  languageValues.toasts.success.visto(event.target.checked)
                );
              })
              .catch(() => {
                SnackbarUtils.error(languageValues.toasts.error.visto);
                dispatch({
                  type: 'setProjeto',
                  payload: { [props.chave]: oldValue },
                });
              });
          }}
          checked={projeto[props.chave] || false}
          disabled={disabledFields || isButtonDisabledByRole}
        />
      </Col>
    </Row>
  ) : (
    <Fragment />
  );
}
